import React, { useState, useEffect } from "react";
import axios from "../../services/api";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Form, Row, Col } from "react-bootstrap";


const VendorForm = ({ show, handleClose, fetchVendors, editingVendor }) => {
  const [vendor, setVendor] = useState({
    name: "",
    contact_person: "",
    phone: "",
    email: "",
    address: "",
    pan_gst: "",
  });

  const [error, setError] = useState("");

  useEffect(() => {
    if (editingVendor) {
      setVendor(editingVendor);
    } else {
      setVendor({ name: "", contact_person: "", phone: "", email: "", address: "",pan_gst: "" });
    }
    setError("");
  }, [editingVendor]);

  const handleChange = (e) => {
    setVendor({ ...vendor, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      if (editingVendor) {
        await axios.put(`/vendors/${vendor.id}`, vendor);
        alert("Vendor Updated Successfully");
      } else {
        await axios.post("/vendors", vendor);
        alert("Vendor Added Successfully")
      }
      fetchVendors();
      handleClose();
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setError(error.response.data.message);
      } else {
        setError("An error occurred while saving the vendor.");
      }
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title className="fw-bold">{editingVendor ? "Edit Vendor" : "Add Vendor"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="p-3 border rounded shadow-sm bg-light">
          {error && <div className="alert alert-danger text-center">{error}</div>}
          
          <Form onSubmit={handleSubmit}>
            <Row className="mb-2">
              <Col md={12}>
                <Form.Group>
                  <Form.Label>Vendor Name</Form.Label>
                  <Form.Control type="text" name="name" placeholder="Enter vendor name" value={vendor.name} onChange={handleChange} required />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-2">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Contact Person</Form.Label>
                  <Form.Control type="text" name="contact_person" placeholder="Enter contact person" value={vendor.contact_person} onChange={handleChange} required />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Phone</Form.Label>
                  <Form.Control type="text" name="phone" placeholder="Enter phone number" value={vendor.phone} onChange={handleChange} required />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-2">
              <Col md={12}>
                <Form.Group>
                  <Form.Label>Email</Form.Label>
                  <Form.Control type="email" name="email" placeholder="Enter email" value={vendor.email} onChange={handleChange} required />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={12}>
                <Form.Group>
                  <Form.Label>Address</Form.Label>
                  <Form.Control as="textarea" name="address" placeholder="Enter address" value={vendor.address} onChange={handleChange} required rows={2} />
                </Form.Group>
              </Col>
            </Row>
			<Row className="mb-2">
              <Col md={12}>
                <Form.Group>
                  <Form.Label>PAN/GST No.</Form.Label>
                  <Form.Control type="text" name="pan_gst" placeholder="Enter PAN/GST No" value={vendor.pan_gst} onChange={handleChange} required />
                </Form.Group>
              </Col>
            </Row>
            <Button type="submit" variant="primary" className="w-100 fw-bold">
              {editingVendor ? "Update Vendor" : "Add Vendor"}
            </Button>
          </Form>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default VendorForm;
